const captchaKey: string = process.env.REACT_APP_CAPTCHA_KEY as string;

export default captchaKey;
